/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { RolesContants } from "../../contants";
import { dataActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import {
  GetLoanAllReport,
  GetLoanReport,
} from "../../services/Actions/dataAction";
import RenderLoanPage from "../RenderLoanPage";
import { COHORT } from "../../Components/CohortFilter";
import ReportWorkspace from "../../Components/ReportWorkspace";

function ReportLoans() {
  const dispatch = useDispatch();
  const { ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  const [formData, setFormData] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });
  // Which button triggered the current download: "range" | "all" | null
  const [activeAction, setActiveAction] = useState(null);
  // Nurses and UPNMG staff are reported separately — generate one, then the
  // other, rather than a single report mixing both cohorts.
  const [cohort, setCohort] = useState(COHORT.MEMBERS);
  const memberType = cohort === COHORT.STAFF ? "STAFF" : undefined;

  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  const { isLoading, response } = data;

  useEffect(() => {
    dispatch(GetUserProfile());
  }, [dispatch]);

  // Clear the active button once the download finishes
  useEffect(() => {
    if (!isLoading) setActiveAction(null);
  }, [isLoading]);

  // Any loan officer (or admin) may generate loan reports.
  const isAuthorized = () =>
    user?.role?.includes(RolesContants.ADMIN) ||
    user?.role?.includes(RolesContants.LOAN_OFFICER) ||
    user?.role?.includes(RolesContants.LOAN_OFFICER_AUTHORIZER) ||
    user?.role?.includes(RolesContants.LOAN_OFFICER_HEAD);

  const handleGenerate = () => {
    if (!isAuthorized()) {
      toast.error("You are not authorized to generate report on loans");
      return;
    }
    if (!formData.category) {
      toast.error("Select a status to generate the report");
      return;
    }
    if (!formData.fromDate || !formData.toDate) {
      toast.error("Choose the date range. This is required");
      return;
    }
    if (formData.fromDate > formData.toDate) {
      toast.error("The end date must be on or after the start date");
      return;
    }
    setActiveAction("range");
    dispatch(
      GetLoanReport({
        ...formData,
        is_all: false,
        isOneDomain: false,
        member_type: memberType,
      })
    );
  };

  const handleGenerateAll = () => {
    if (!isAuthorized()) {
      toast.error("You are not authorized to generate report on loans");
      return;
    }
    setActiveAction("all");
    dispatch(GetLoanAllReport(memberType));
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    }
  }, [response?.state, ResetDataResponse]);

  return (
    <RenderLoanPage title="Loan reports" page={12} hidePageHeading>
      <ReportWorkspace
        title="Loan reports"
        formData={formData}
        setFormData={setFormData}
        cohort={cohort}
        onCohortChange={setCohort}
        isLoading={isLoading}
        activeAction={activeAction}
        onGenerate={handleGenerate}
        onGenerateAll={handleGenerateAll}
      />
      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default ReportLoans;
